// Parts
var TEMPLATES = {};
import filterHandler from './parts/filter.js';

//Coverflow view
import template_coverflow from './parts/template_coverflow.js';
TEMPLATES.coverflow = template_coverflow;

//List view
import template_list from './parts/template_list.js';
TEMPLATES.list = template_list;

export default class extends HTMLElement {

  static get observedAttributes() {
    return ['settings','query'];
  }

  constructor() {
    super();
    console.log('Init DSBList');
    this.uuid = this._createUUID();
    this._id = this._createUUID();
    this._dataHandler = false;
    this._contentElements={};
    this._contentElements.list=null;
    this._contentElements.loader=null;
    this._contentElements.filter=null;
    this._contentElements.top=null;
    this._contentElements.middle=null;
    this._contentElements.bottom=null;
    this._update_skip = {};
    this._has_filter_hook = false;
    this._update_running = false;
    this.app = window.fw_workbench.getApp();

    console.log('this.modal_id='+this.modal_id);
    //window.dispatchEvent(new CustomEvent('dsb-pwa-add_modal', {detail: {id:this.modal_id}}));
    //window.dispatchEvent(new CustomEvent('dsb-pwa-append_tray', {detail: {tray_id: this.modal_id}}));
    this.registeredListners=[];
  }

  disconnectedCallback()
  {
    this._log('debug','disconnectedCallback','Init');

    // Clean listners
    this._clean_registeredListners();

    // Clean out hooks
    this._clean_hooks();

    this._log('debug','disconnectedCallback','End');
  }

  _clean_hooks()
  {
    if('remove_hook' in this.app && typeof this.app.remove_hook == 'function')
    {
      this.app.remove_hook(this.uuid);
    }
  }

  _clean_registeredListners()
  {
    this._log('debug','_clean_registeredListners','Cleaning...');
    for(let i=0;i<this.registeredListners.length;i++)
    {
      try
      {
        if('type' in this.registeredListners[i] && 'object' in this.registeredListners[i])
        {
          switch(this.registeredListners[i].type)
          {
            case "Interval":
              window.clearInterval(this.registeredListners[i].object);
              break;
            case "IntersectionObserver":
              if('disconnect' in this.registeredListners[i].object)
              {
                this.registeredListners[i].object.disconnect();
              }
              else
              {
                this._log('warning','disconnectedCallback','Cannot disconnect',this.registeredListners[i]);
              }
              break;
            default:
              this._log('error','disconnectedCallback','Unknown object type '+this.registeredListners[i].type,this.registeredListners[i]);
              break;
          }
        }
      }
      catch(ex)
      {
        this._log('error','disconnectedCallback','Fatal error',ex,this.registeredListners[i]);
      }
    }
    this.registeredListners=[];
  }

  get service() {
      return this.getAttribute('service');
  }

  set service(newValue){
      this.setAttribute('service', newValue);
  }

  get view_mode() {
      return this.getAttribute('view_mode');
  }

  set view_mode(newValue){
      this.setAttribute('view_mode', newValue);
  }

  get settings() {
      if(!this._settings)
      {
          if(typeof this.getAttribute('settings') === 'object' && this.getAttribute('settings') !== null)
          {
              this._settings = this.getAttribute('settings');
          }
          else
          {
            this._settings = JSON.parse(``+this.getAttribute('settings')+``);
          }

          if(this._settings == null)
          {
              this._settings = {};
          }
      }
      return this._settings;
  }

  set settings(newValue){
      if(typeof newValue === 'object' && newValue !== null)
      {
        this._settings = newValue;
      }
      else
      {
          this.setAttribute('settings', newValue);
      }
  }


  get query() {
      return this.getAttribute('query');
  }

  set query(newValue){
      this.setAttribute('query', newValue);
  }

  get root_path() {
      return this.getAttribute('root_path');
  }

  set root_path(newValue){
      this.setAttribute('root_path', newValue);
  }

  get title() {
      return this.getAttribute('title');
  }

  set title(newValue){
      this.setAttribute('title', newValue);
  }

  get type() {
      return this.getAttribute('type');
  }

  set type(newValue){
      this.setAttribute('type', newValue);
  }

  setDataHandler(dataHandler)
  {
    if(typeof dataHandler == 'function')
    {
      this._dataHandler=dataHandler;
    }
  }

  setDSBClient(dsbClient){
      this.dsbClient=dsbClient;
  }

  _log(type,source,message,data='')
  {
    let _message = 'dsb-app/Component/DSBList::'+source+'- '+message;
    switch(type)
    {
       case "debug":
         console.debug(_message,data);
        break;
      case "warning":
         console.warn(_message,data);
        break;
      case "error":
         console.error(_message,data);
        break;
      default:
          console.log(_message,data);
    }
  }

  _createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  async _refresh()
  {
    this.is_refresh = true;

    // Clean listners
    this._clean_registeredListners();
    this._update_skip = {};
    if('catchup' in this.dsbClient.user)
    {
      await this.dsbClient.user.catchup.set('unfiltered',{});
    }
    this._contentElements={};
    this._contentElements.list=null;
    this._contentElements.loader=null;
    this._contentElements.filter=null;
    this._contentElements.top=null;
    this._contentElements.middle=null;
    this._contentElements.bottom=null;
    return this._render();
  }

  async _update()
  {

    let test_mode = false;
    if(!this._update_running)
    {
      this._update_running = true;
      if(test_mode)
      {
        //let _raw_query = this.dsbClient.content.processQuery(this.query,{},'object');
        //this.setAttribute('query',this.dsbClient.content.processQuery(this.query,{'_[limit]':parseInt(_raw_query['_[limit]'])+1}));
        //this.setAttribute('query',this.dsbClient.content.processQuery(this.query,{'type':'post'}));
        //await this._render('update');
      }
      else
      {
        //this.dsbClient.user.is_offline(false,true);
        this._log('debug','_update','Checking for updates...');
        await this._render('update');
      }
      this._update_running = false;
    }

  }


  connectedCallback() {

    return this._render();
  }

  attributeChangedCallback(name, oldValue, newValue)
  {
    if(`settings` == name && oldValue != null)
    {
      console.log('dsb-list::attributeChangedCallback: '+name,oldValue,newValue);
      this._settings = null;
      return this._render();
    }
    if(`query` == name && oldValue != null)
    {
      let diff = this.dsbClient.content.processQuery(oldValue,newValue,'diff');
      console.debug('dsb-list::attributeChangedCallback: '+name,oldValue,newValue,diff);

      // Check for changes
      let mode=null;
      if(('missing' in diff) && Object.keys(diff.missing).length > 0)
      {
        mode='default';
      }
      if(('changed' in diff) && Object.keys(diff.changed).length > 0)
      {
        mode='default';
        if(('_[skip]' in diff.changed) && Object.keys(diff.changed).length == 1)
        {
          mode='append';
        }
        else if(('_[limit]' in diff.changed) && Object.keys(diff.changed).length == 1)
        {
          mode='update';
        }

      }
      mode='update';
      return this._render(mode);
    }
  }

  async _render(mode=null)
  {
    try
    {
      if(mode!==null)
      {
        this.view_mode=mode;
      }
      else if(this.view_mode == null)
      {
        this.view_mode = 'default';
      }

      console.debug('dsb-list::_render view_mode overide='+mode,this.view_mode);
      let _this = this;
      let _raw_query = _this.dsbClient.content.processQuery(this.query,{},'object');

      let function__navigateItems = function(direction,current_id){

        if(this._contentElements.list instanceof HTMLUListElement)
        {
          let next_li = this._contentElements.list.getElementsByTagName("li")[(current_id+1)];
          if(next_li instanceof HTMLLIElement)
          {
            return next_li.click();
          }
          else
          {
           console.error('function__navigateItems: Not found next LI');
          }
        }
        //_this.setAttribute('query',_this.dsbClient.content.processQuery(_this.query,{'_[skip]':parseInt(_raw_query['_[skip]'])+parseInt(_raw_query['_[limit]'])}));

      }

      if(this.view_mode=='default')
      {
        if(this._contentElements.list instanceof HTMLElement || this._contentElements.filter instanceof HTMLElement)
        {
          this._contentElements.list = document.createElement("div");
          this._contentElements.list.innerHTML = `<maa-spinner></maa-spinner>`;
        }
        else
        {
          this.innerHTML = `<maa-spinner></maa-spinner>`;
        }
      }

      // Get data
      let endpoint_service=this.service;
      let endpoint_type='content';
      if(endpoint_service.includes('::'))
      {
        endpoint_service=endpoint_service.split('::');
        if(endpoint_service[0])
        {
          endpoint_type=endpoint_service[0];
        }
        endpoint_service=endpoint_service[1];
      }
      let json = false;
      if(endpoint_type=='user')
      {
        _this._log('debug','Getting from user endpoint '+endpoint_service,this.dsbClient.content.processQuery(this.query,{},'process'));
        json = await this.dsbClient.user.get(endpoint_service,"?"+this.dsbClient.content.processQuery(this.query,{},'process')+'#sw:fresh',true);
      }
      else if(endpoint_type=='data')
      {
        if('_dataHandler' in this && typeof this._dataHandler == 'function')
        {
          json = await this._dataHandler(this.dsbClient.content.processQuery(this.query,{},'object'));
        }
        else
        {
          throw "Missing _dataHandler or not a function";
        }
      }
      else
      {
        if(endpoint_service=='static')
        {
          json = await this.dsbClient.content.get(endpoint_service,this.query,true);
        }
        else
        {
          json = await this.dsbClient.content.get(endpoint_service,"?"+this.dsbClient.content.processQuery(this.query,{},'process')+'',true);
        }
      }

      // Format results
      if (json && 'state' in json && json.state == 'success')
      {
        this.settings.user_settings={};
        if(!('apply-content-filter' in this.settings))
        {
          this.settings['apply-content-filter']='off';
        }

        if(this.settings['apply-content-filter']!='off')
        {
          this.settings.user_settings.content_filter_categories = {};
          let _content_filter_categories = await _this.dsbClient.user.custom_settings.get_setting('content_filter_categories');
          if(_content_filter_categories && typeof _content_filter_categories == 'object' && 'fields' in _content_filter_categories)
          {
            let _show_ids={};
            for(let cat_key in _content_filter_categories.fields)
            {
              let off = false;
              if('settings' in _content_filter_categories.fields[cat_key])
              {
                if('text_type' in _content_filter_categories.fields[cat_key].settings && _content_filter_categories.fields[cat_key].settings.text_type=='hidden')
                {
                  off=true;
                }
              }
              if('user_data' in _content_filter_categories.fields[cat_key])
              {
                if(_content_filter_categories.fields[cat_key].user_data=='off')
                {
                  off=true;
                }
              }

              let ids = _content_filter_categories.fields[cat_key].value.split('|');
              for(let i =0;i<ids.length;i++)
              {
                if(off && !ids[i].startsWith('!'))
                {
                  this.settings.user_settings.content_filter_categories[ids[i]]=true;
                }
                else
                {
                  _show_ids[ids[i]]=true;
                }
              }
            }

            for(let content_filter_categories_id in this.settings.user_settings.content_filter_categories)
            {
              if( content_filter_categories_id in _show_ids)
              {
                delete this.settings.user_settings.content_filter_categories[content_filter_categories_id]
              }
            }
            _this._log('debug','_render','content_filter_categories',this.settings.user_settings.content_filter_categories);
          }

          // Only add hooks on
          if(!this._has_filter_hook)
          {
            if('add_hook' in this.app && typeof this.app.add_hook == 'function')
            {
              this.app.add_hook(this.uuid,'updated_setting-content_filter_categories',function(_this_element){
                if('_refresh' in _this_element && typeof _this_element._refresh == 'function')
                {
                  _this_element._refresh();
                }
              },this);
              this._has_filter_hook=true;
            }
          }

          // Pre-process results
          if('data' in json)
          {

            for(let i = 0; i < json.data.length; i++)
            {
              let current_data = json.data[i];
              if(typeof current_data === 'object' && 'type' in current_data)
              {
                // Check for content_filter_categories
                if(typeof this.settings.user_settings.content_filter_categories == 'object')
                {
                  if('taxonomies' in current_data
                    && typeof current_data.taxonomies=='object'
                    && 'category' in current_data.taxonomies
                    && typeof current_data.taxonomies.category=='object'
                    && 'list' in current_data.taxonomies.category
                  )
                  {
                    let has_filter = 'no';

                    for(let ii = 0; ii < current_data.taxonomies.category.list.length; ii++)
                    {
                        if( current_data.taxonomies.category.list[ii] in this.settings.user_settings.content_filter_categories)
                        {
                          has_filter=i;
                          continue;
                        }
                    }
                    if(!isNaN(has_filter))
                    {
                      if('catchup' in this.dsbClient.user)
                      {
                        //console.error('@catchup',current_data.taxonomies.category.list,this.settings.user_settings.content_filter_categories);
                        await this.dsbClient.user.catchup.set('unfiltered',JSON.parse(JSON.stringify(current_data)),current_data.id);
                        this._log('debug','_render/filter__content_filter_categories','Filter out (skipp) "'+current_data.id+'"',this.settings.user_settings.content_filter_categories[current_data.taxonomies.category.list[has_filter]]);
                        json.data.splice(has_filter,1);
                      }
                    }
                  }
                }
              }
            }

            for(let i = 0; i < json.data.length; i++)
            {
              let current_data = json.data[i];
              if(typeof current_data === 'object' && 'type' in current_data)
              {
                if(`omit_by_post_tags` in this.settings && Array.isArray(this.settings.omit_by_post_tags))
                {
                  this._log('debug','_render/filter__omit_by_post_tags','Omit by post_tag, checking...');
                  if(('taxonomies' in current_data) && ('post_tag' in current_data.taxonomies) && ('slugs' in current_data.taxonomies.post_tag) && (Array.isArray(current_data.taxonomies.post_tag.slugs)))
                  {
                    let has_filter = 'no';
                    for(let ii = 0; ii < this.settings.omit_by_post_tags.length; ii++)
                    {
                      if(current_data.taxonomies.post_tag.slugs.includes(this.settings.omit_by_post_tags[ii]))
                      {
                        has_filter=i;
                        this._log('debug','_render/filter__omit_by_post_tags','Omit by post_tag (skipp) - has filter @ '+i);
                      }
                    }

                    if(!isNaN(has_filter))
                    {
                      json.data.splice(has_filter,1);
                      this._log('debug','_render/filter__omit_by_post_tags','Filter out (skipp)');
                    }
                  }
                }
              }
            }
          }
        }

        // get any injected results
        if(`insert` in this.settings && typeof this.settings.insert === 'object' && this.settings.insert !== null)
        {
          for(let aNewItem in this.settings.insert)
          {
            if(typeof this.settings.insert[aNewItem] === 'object' && this.settings.insert[aNewItem] !== null && 'data' in this.settings.insert[aNewItem])
            {
              let post_settings={};
              post_settings.toolbar='off';

              // Check for has_unfiltered
              if('condition' in this.settings.insert[aNewItem].data)
              {
                if(this.settings.insert[aNewItem].data.condition == 'has_unfiltered')
                {
                  if(!await this.dsbClient.user.catchup.has('unfiltered'))
                  {
                    continue;
                  }
                }
              }

              let aNewItemId=aNewItem;

              if(!Array.isArray(json.data))
              {
                json.data = [];
              }

              if(!json.data.indexOf(aNewItem))
              {
                json.data.push(this.settings.insert[aNewItem].data);
              }
              else
              {
                json.data.splice((parseInt(aNewItem)-1), 0, this.settings.insert[aNewItem].data);
                aNewItemId=(parseInt(aNewItem)-1);
              }



               // Add or update post settings (for rendering post)
              if(!('item' in this.settings))
              {
                this.settings.item={};
              }
              if(!(aNewItemId in this.settings.item))
              {
                this.settings.item[aNewItemId]={};
              }
              if(!( 'post' in this.settings.item[aNewItemId]))
              {
                this.settings.item[aNewItemId]['post']={};
              }
              for(let apost_setting in post_settings)
              {
                this.settings.item[aNewItemId]['post'][apost_setting]=post_settings[apost_setting];
              }
            }
          }
        }

        var infinateScrollObserver = false;

        // Setup search
        if(`show-search` in this.settings && !(this._contentElements.filter instanceof HTMLFormElement))
        {
            filterHandler(this.settings['show-search'],_raw_query, this);
        }

        // Remove loader
        if(this._contentElements.loader instanceof HTMLElement)
        {
            if(infinateScrollObserver instanceof IntersectionObserver)
            {
              infinateScrollObserver.unobserve(this._contentElements.loader);
            }
            this._contentElements.loader.remove();
            this._contentElements.loader=null;
        }

        if(!(`template` in this.settings))
        {
          this.settings.template = 'default';
        }


        if(this.settings.template == 'default')
        {
          this.settings.template = 'list';
        }

        if(json.data.length==0)
        {
          if(this.view_mode=='append' || this.view_mode=='update')
          {
            return;
          }
        }


          // Setup list
          if(this.view_mode=='default' || !(this._contentElements.list instanceof HTMLUListElement))
          {
            this._contentElements.list = document.createElement("ul");
          }

          // Setup Top
          if(this.view_mode=='default' || !(this._contentElements.top instanceof HTMLElement))
          {
            this._contentElements.top = document.createElement("div");
            this._contentElements.top.classList.add('top');
          }

          // Setup Middle
          if(this.view_mode=='default' || !(this._contentElements.middle instanceof HTMLElement))
          {
            this._contentElements.middle = document.createElement("div");
            this._contentElements.middle.classList.add('middle');
          }

          // Setup bottom
          if(this.view_mode=='default' || !(this._contentElements.bottom instanceof HTMLElement))
          {
            this._contentElements.bottom = document.createElement("div");
            this._contentElements.bottom.classList.add('bottom');
          }

          // Setup Infinate scroll
          if(`navigation` in this.settings && (`infinate_scroll` == this.settings.navigation) && (('_[limit]' in _raw_query) && json.data.length>=_raw_query['_[limit]']))
          {
              // Create Observer
              var infinateScrollObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                      _this.setAttribute('query',_this.dsbClient.content.processQuery(_this.query,{'_[skip]':parseInt(_raw_query['_[skip]'])+parseInt(_raw_query['_[limit]'])}));
                    }
                });
              });
              this._contentElements.loader = document.createElement("li");
              this._contentElements.loader.classList.add('item');
              this._contentElements.loader.innerHTML = "<maa-spinner/>";
          }

          let default_image = '../images/default-image.svg';
          if(_this.dsbClient.content.app_path)
          {
              default_image = _this.dsbClient.content.app_path+'/images/default-image.svg';
          }

          let missing_image = '../images/fwi-logo-grey.svg';
          if(_this.dsbClient.content.app_path)
          {
              missing_image = _this.dsbClient.content.app_path+'/images/fwi-logo-grey.svg';
          }

          var functon_imageExists = function(url, callback) {
              var img = new Image();
              img.onload = function() { callback(true,url); };
              img.onerror = function() { callback(false,url); };
              img.src = url;
          }
          var imageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                  var image = entry.target;
                  functon_imageExists(image.dataset.img,function(exists,img){
                      if(exists)
                      {
                          image.setAttribute('style', 'background-image:url('+img+')');
                      }
                      else
                      {
                          image.setAttribute('style', 'background-image:url('+missing_image+');background-size: auto;');
                      }
                      imageObserver.unobserve(image);
                  });

              }
            });
          });

          // Setup item handler
          if(this.view_mode=='default')
          {
            // Run init
            if((this.settings.template in TEMPLATES) && `init` in TEMPLATES[this.settings.template])
            {
              await TEMPLATES[this.settings.template].init(_this,{'imageObserver':imageObserver,'default_image':default_image,'missing_image':missing_image});
            }

            // Run pre_render
            if((this.settings.template in TEMPLATES) && `pre_render` in TEMPLATES[this.settings.template])
            {
              await TEMPLATES[this.settings.template].pre_render(json.data);
            }
          }

          // Set item position
          let list_position = 0;
          if((this.settings.template in TEMPLATES) && `get_list_count` in TEMPLATES[this.settings.template])
          {
            list_position = TEMPLATES[this.settings.template].get_list_count();
          }
          else
          {
            list_position = this._contentElements.list.childNodes.length;
          }

          if(json.data.length == 0)
          {
            // Run render
            if((this.settings.template in TEMPLATES) && `render` in TEMPLATES[this.settings.template])
            {
              let item_settings = {};
              if(`no-results` in this.settings)
              {
                  item_settings=this.settings[`no-results`];
              }
              let item = document.createElement("li");
              item.style='list-style: none;margin:auto;';
              await TEMPLATES[this.settings.template].render(0,{type:'no-results'},item,item_settings);
              this._contentElements.list.append(item);
            }
            else
            {
              throw 'Missing template '+this.settings.template;
            }
          }
          else
          {
            // Itterate through results
            for(let i = 0; i < json.data.length; i++)
            {
              let current_data = json.data[i];
              if(typeof current_data === 'object' && 'type' in current_data)
              {
                let item_settings = {};
                for(let aSetting in this.settings)
                {
                    if(aSetting != `item`)
                    {
                        item_settings[aSetting] = this.settings[aSetting];
                    }
                }

                if(`item` in this.settings && ( list_position in this.settings.item))
                {
                    for(let aSetting in this.settings.item[list_position])
                    {
                        item_settings[aSetting] = this.settings.item[list_position][aSetting];
                    }
                }

                let _skipable_id = this.settings.template+'_'+('type' in current_data?current_data.type+'_':'unknowntype')+current_data.id;

                // If we're updating and already have this id in _update_skip... skip we already have it.
                if(this.view_mode=='update' && (('updatable' in item_settings) && item_settings.updatable == 'true'))
                {
                    if(_skipable_id in this._update_skip)
                    {
                      this._log('debug','_render/'+this.settings.template,'Skipping as we already have "'+_skipable_id+'" in _update_skip ('+list_position+')',this._update_skip);
                      continue;
                    }
                }

                if(i==0 && list_position>0)
                {
                  list_position=list_position+1;
                }
                else
                {
                  list_position++;
                }

                let item = document.createElement("li");
                let item_title = '';

                // Run render
                if((this.settings.template in TEMPLATES) && `render` in TEMPLATES[this.settings.template])
                {
                  item.setAttribute('data-uid',_skipable_id);
                  this._update_skip[_skipable_id]=true;;
                  await TEMPLATES[this.settings.template].render(list_position,current_data,item,item_settings);
                }
                else
                {
                  throw 'Missing template '+this.settings.template;
                }

                if((`add_order` in this.settings) && this.settings.add_order == 'prepend')
                {
                  this._contentElements.list.prepend(item);
                }
                else
                {
                  this._contentElements.list.append(item);
                }
              }
              else
              {
                throw 'Missing type in json.data';
              }
            }
          }

          // Add infinate scroll
          if(infinateScrollObserver)
          {
              infinateScrollObserver.observe(this._contentElements.loader);
              this._contentElements.list.append(this._contentElements.loader);
          }
        //}

        if(this.view_mode=='default')
        {
          this.innerHTML = '';
        }

        if(this.view_mode=='default')
        {
          if(this._contentElements.top instanceof HTMLElement)
          {
              this.append(this._contentElements.top);
          }

          if(this._contentElements.filter instanceof HTMLElement)
          {
              this.append(this._contentElements.filter);
          }
          if(this._contentElements.middle instanceof HTMLElement && this._contentElements.list instanceof HTMLElement)
          {
              this._contentElements.middle.append(this._contentElements.list);
              this.append(this._contentElements.middle);
          }

          if(this._contentElements.bottom instanceof HTMLElement)
          {
              this.append(this._contentElements.bottom);
          }

          // Run post
          if((this.settings.template in TEMPLATES) && `post_render` in TEMPLATES[this.settings.template])
          {
            await TEMPLATES[this.settings.template].post_render();
          }
        }
      }
      else
      {
        throw {message:'Problem with json or json.state',data:json};
      }
    }
    catch(ex)
    {
      try
      {
        console.error('dsb-list:: Error',ex);
        // Run post
        if((`template` in this.settings) && (this.settings.template in TEMPLATES) && `error` in TEMPLATES[this.settings.template])
        {
          await TEMPLATES[this.settings.template].error(ex);
        }
        else
        {
          let is_offline = await this.dsbClient.user.is_offline();
          if(is_offline)
          {
            if(is_offline == 'maintenance')
            {
              this.innerHTML = `
              <div style="height: var(--fwwb-fullheight);">
              <article class="error-503" role="article">
                <p>Maintenance work ongoing...</p>
                <p>Sorry we are currently performing maintenance please <a href="javascript:return;" onclick="window.location.reload(false);">click here</a> to try again or check back later.</p>
              </article>
              </div>`;
            }
            else
            {
              this.innerHTML = `
              <div style="height: var(--fwwb-fullheight);">
              <article class="error-90" role="article">
                <p>Offline</p>
                <p>Sorry, offline version not available.<br/>Please try again later when you have an internet connection :)</p>
              </article>
              </div>`;
            }
          }
          else
          {
            this.innerHTML = `
                <div style="height: var(--fwwb-fullheight);">
                      <article class="error-500" role="article">
                        <p>Sorry an error has occured.</p>
                        <p>Please try again by <a href="javascript:return;" onclick="window.location.reload(true);">clicking here</a> or try again later.</p>
                        <details>
                        <summary>Details</summary>
                        <div>
                          Type: General error<br/>
                          `+JSON.stringify(ex)+`
                        </div>
                      </details>
                      </article>
                  </div>`;
          }
        }
      }
      catch(exex)
      {
        console.error('dsb-list:: Error in error handling!',ex);
        this.innerHTML = `
          <div style="height: var(--fwwb-fullheight);">
                <article class="error-500" role="article">
                  <p>Sorry an error has occured.</p>
                  <p>Please try again by <a href="javascript:return;" onclick="window.location.reload(true);">clicking here</a> or try again later.</p>
                  <details>
                  <summary>Details</summary>
                  <div>
                    Type: Fatal error<br/>
                    `+JSON.stringify(ex)+`<br/>
                    `+JSON.stringify(exex)+`
                  </div>
                </details>
                </article>
            </div>`;
      }
      return;
    }
  }
}


